// extracted by mini-css-extract-plugin
module.exports = {"RichText":"RichText_RichText__J6OdI","RichText___website":"RichText_RichText___website__3NJoN"};